// className helper. Light wrapper over clsx so future tracks can swap in
// tailwind-merge without churning every component.
import clsx, { type ClassValue } from 'clsx';

export function cn(...args: ClassValue[]): string {
  return clsx(...args);
}
